var window=global;var $CLJS=require("./cljs_env.js");require("./cljs.core.js");
'use strict';$CLJS.ZY=new $CLJS.M(null,"force?","force?",1839038675);$CLJS.$Y=new $CLJS.M(null,"cache-fn","cache-fn",5561939);